export default __webpack_public_path__ + "static/media/Network-encryption-diagram.bbfc93ea.svg";